const errorCodes = {
    400: `Couldn't perform operation, malformed request sent!`,
    404: `Couldn't perform operation, endpoint not found!`,
    405: `Couldn't perform operation, method is not allowed!`,
    408: `Request timed out. Are you sure your connected to the internet?`,
    418: `The server refuses to brew coffee because it is, permanently, a teapot.`,
    429: `You've been bombarding us with requests! Might want to take it a bit slower.`,
    500: `There was a problem completing the action. Our engineers have been notified. Please try again later.`,
    503: `Server seems to be unresponsive. Please make sure you are connected to the internet.`,
    default: "Oops! There was an error performing the action. Please try again!",
    timedout: `Request timed out. Are you sure your connected to the internet?`,
};

export class StatusError extends Error {
    private status: number;

    constructor(message, status: number) {
        super(message);
        this.status = status;
    }
}

export default errorCodes;
